import { FC, PropsWithChildren } from 'react';

import { useIntl } from 'react-intl';

import {
  BenefitText,
  Container,
  ContentText,
  InfoBadge,
  InfoContainer,
  InfoText,
  SectionTitle,
  StyledImage,
  Title,
} from './styled';

const walmartMembershipImg = require('./walmart-membership-image.png');

export const WalmartMembership: FC<PropsWithChildren<{}>> = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <SectionTitle>{formatMessage({ id: 'dontHaveWalmartAccount' })}</SectionTitle>
      <Container>
        <StyledImage source={walmartMembershipImg} />
        <Title>{formatMessage({ id: 'royalPerksMembersEnjoy' })}</Title>
        <BenefitText>{formatMessage({ id: 'walmartPlusBenefit' })}</BenefitText>
        <ContentText>{formatMessage({ id: 'walmartMembershipSignUp' })}</ContentText>
        <ContentText>{formatMessage({ id: 'walmartAdditionalFreeMonths' })}</ContentText>
        <InfoContainer>
          <InfoBadge>
            <InfoText>{formatMessage({ id: 'walmartMembershipDeal' })}</InfoText>
          </InfoBadge>
        </InfoContainer>
      </Container>
    </>
  );
};
